
export interface Field {
  name: string;
  type: 'number' | 'number2' | 'text' | 'boolean'; 
}

const apartmentFields: Field[] = [
  { name: "Tamaño", type: "number2" },
  { name: "Piso", type: "number2" },
  { name: "Habitaciones", type: "number" },
  { name: "Balcón", type: "boolean" },
  { name: "Huéspedes", type: "number" },
  { name: "Camas", type: "number" },
  { name: "Baños", type: "number" }
];

const houseFields: Field[] = [
  { name: "Tamaño", type: "number2" },
  { name: "Pisos", type: "number" },
  { name: "Jardín", type: "boolean" },
  { name: "Terraza", type: "boolean" },
  { name: "Habitaciones", type: "number" },
  { name: "Huéspedes", type: "number" },
  { name: "Camas", type: "number" },
  { name: "Baños", type: "number" }
];

const towerFields: Field[] = [
  { name: "Tamaño", type: "number2" },
  { name: "Pisos", type: "number" },
  { name: "Niveles", type: "number" },
  { name: "Cantidad de piscinas", type: "number" },
  { name: "Cantidad de parrillas", type: "number" },
  { name: "Balcón o Terraza", type: "boolean" },
  { name: "Azotea", type: "boolean" },
  { name: "Disponible desde", type: "text" },
  { name: "Área social", type: "text" },
];

export const FieldsByPropertyCategory: Record<string, Field[]> = {
  "Apartamento": apartmentFields,
  "Apartamento Loft": apartmentFields,
  "Apartamento Estudio": apartmentFields,
  
  "Casa": houseFields,
  "Casa Adosada": houseFields,
  "Casa de Lujo": houseFields,
  "Casa independiente": houseFields,
  "Mansión":houseFields,
  "Torre": towerFields,

  "Lote": [
    { name: "Tamaño", type: "number2" },
    { name: "Tipo de terreno", type: "text" },
    { name: "Zonificación", type: "text" }
  ],
  "Condominio": [
    { name: "Tamaño", type: "number2" },
    { name: "Casas", type: "number" },
    { name: "Húespedes", type: "number" }
  ],
  "Terreno": [
    { name: "Tamaño", type: "number2" },
    { name: "tipoTerreno", type: "text" }
  ],
  "Propiedad Comercial": [
    { name: "Tamaño", type: "number2" },
    { name: "tipoComercial", type: "text" },
    { name: "Habitaciones", type: "number" },
    { name: "Huéspedes", type: "number" }
  ],
  "Finca": [
    { name: "Tamaño", type: "number2" },
    { name: "tipoFinca", type: "text" }
  ],
  "Moderna": [], 
  "Rústica": [], 
  "Oficentro": [], 
  "Mall": [], 
  "Local": [
    { name: "Tamaño", type: "number2" },
    { name: "tipoComercial", type: "text" },
    { name: "Habitaciones", type: "number" },
    { name: "Huéspedes", type: "number" }
  ]
};
